export default "__VITE_ASSET__C7MFQ4ES__"